import * as React from "react";
import {
  AppBar,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";

import "simplebar-react/dist/simplebar.min.css";

export default function LayerSettingsContainer(props) {
  const isMobil = !useMediaQuery("(min-width:900px)");
  const mobilePanelTop = 220;
  const mobilePanelWidth = "min(320px, calc(100vw - 32px))";

  if (isMobil) {
    if (!props.extended) {
      return (
        <Box
          sx={{
            position: "fixed",
            right: 0,
            top: `${mobilePanelTop}px`, 
            width: 120,          
            zIndex: 150,
            backgroundColor: "rgba(55,55,55,0.9)",
            borderRadius: "10px 0 0 10px",
            boxShadow: 3,
          }}
        >
          <IconButton
            aria-label="Layer-Einstellungen oeffnen"
            onClick={() => {
              props.setHeaderExtended(true);
            }}
            sx={{
              display: "flex",
              gap: 1,
              color: "#fff",
              px: 1.5,
              py: 1,
            }}
          >
            <LayersOutlinedIcon />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Layers
            </Typography>
          </IconButton>
        </Box>
      );
    }

    return (
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          right: 0,
          top: `${mobilePanelTop}px`,
          bottom: "auto",
          left: "auto",
          width: mobilePanelWidth,
          backgroundColor: "rgba(55,55,55,0.95)",
          borderRadius: "12px 0 0 12px",
          zIndex: 1500,
          px: 2,
          py: 1.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LayersOutlinedIcon />
            <Typography variant="h6">Layers</Typography>
          </Box>
          <IconButton
            aria-label="Layer-Einstellungen schliessen"
            color="inherit"
            onClick={() => {
              props.setHeaderExtended(false);
            }}
            sx={{ p: 0.5 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            mt: 2,
            maxHeight: "45vh",
            overflowY: "auto",
            pr: 1,
          }}
        >
          {props.children}
        </Box>
      </AppBar>
    );
  }

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        style={{
          top: "65px",
          paddingBottom: "10px",
          backgroundColor: "rgba(55,55,55,0.9)",
          zIndex: 1050,
          height: props.extended ? "auto" : "70px",
          width: props.extended ? "310px" : "125px",
          //transition: "transform 0.5s ease, opacity 0.5s ease", // Smooth transform and opacity
        }}
      >
        {props.extended ? (
          <Typography variant="h5" sx={{ margin: "20px 0 0 180px" }}>
            Layers{" "}
          </Typography>
        ) : (
          <Typography
            variant="h5"
            sx={{
              margin: "20px 0 0 35px",
            }}
          >
            Layers
          </Typography>
        )}
        <IconButton
          style={{
            position: "absolute",
            marginTop: "15px",
            marginLeft: "1px",
          }}
          edge="start"
          color="inherit"
          onClick={(ev) => {
            props.setHeaderExtended(!props.extended);
          }}
        >
          {props.extended ? (
            <ArrowForwardIosIcon style={{ width: "30px" }} />
          ) : (
            <ArrowBackIosNewIcon />
          )}
        </IconButton>

        {props.extended && (
          <>
            <Box sx={{ marginTop: "20px" }}>{props.children}</Box>
          </>
        )}
      </AppBar>
    </>
  );
}
